export default __webpack_public_path__ + "static/media/msx.931162ea.jpg";